let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("kjZZD"), load("ffEVr"), load("e19Zv")]).then(() => parcelRequire('nSMSQ'));